export const parseTargetPath = (
  targetPath: string,
): { relativePath: string; queryParams: Record<string, string> } => {
  const url = new URL(`${window.location.origin}${targetPath}`);
  const queryParams: Record<string, string> = {};
  url.searchParams.forEach((value, key) => {
    queryParams[key] = value;
  });
  return { relativePath: url.pathname, queryParams };
};
